import { Component, ElementRef, EventEmitter, Input, Output } from '@angular/core';
import { Router } from '@angular/router';
import { LayoutService } from '@shared/services/layout/layout.service';
import { ExecutiveService } from 'src/app/shared/services/executive/executive.service';
@Component({
  selector: 'app-breadcrumb',
  templateUrl: './breadcrumb.component.html',
  styleUrls: ['./breadcrumb.component.scss'],
})
export class BreadcrumbComponent {
  @Input() isAsset = false;
  @Output() hiddenAsset = new EventEmitter<boolean>();
  isSupervisor: boolean = false;
  isBoss: boolean = false;

  constructor(executiveService: ExecutiveService, public router: Router, layout: LayoutService, el: ElementRef) {
    layout.addComponentHeight(el);
    this.isSupervisor = executiveService.executiveModel.executiveProfile.isSupervisor;
    this.isBoss = executiveService.executiveModel.executiveProfile.isBoss;
  }

  showAssetPage() {
    this.hiddenAsset.emit(true);
  }

  buscadorCliente() {
    this.router.navigate(['/main/client-search']);
  }
}
